import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { FloatingWhatsApp } from './FloatingWhatsApp';

export const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white font-sans text-neutral-900">
      <Navbar />

      <main id="main-content" className="flex-grow" tabIndex={-1}>
        {children}
      </main>

      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};